import { RouterType } from 'shared-routing';
import { useEffect } from 'react';
import { parseDateToString } from '@utils/helpers';

export const useCheckForArrivalDate = ({
  newArrivalDate,
  router,
  route,
}: {
  newArrivalDate: string;
  router: RouterType;
  route: string;
}): void =>
  useEffect(() => {
    const { arrivalDate } = router.query;
    if (!arrivalDate) {
      router.replace({
        pathname: route,
        query: { ...router.query, arrivalDate: parseDateToString(newArrivalDate) },
      });
    }
  }, []);
